import { render } from "./ProfileDetail.vue?vue&type=template&id=3997aa5d&scoped=true"
import script from "./ProfileDetail.vue?vue&type=script&lang=js"
export * from "./ProfileDetail.vue?vue&type=script&lang=js"

import "./ProfileDetail.vue?vue&type=style&index=0&id=3997aa5d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3997aa5d"]])

export default __exports__